// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#pwb-container {
  display: none;
}
#pwb-container.show-add-accounts {
  display: block;
}

@media (max-width: 400px) {
  .accountlist-grid { /* Adjust width as needed */ }
  .accountlist-grid .radio-label ion-col {
    font-size: 0.8rem; /* Reduce font size */
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/deposit/deposit-paywithmybank/deposit-paywithmybank.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,cAAA;AACR;;AAKI;EADJ,oBACgC,2BAAA,EAAA;EACxB;IACI,iBAAA,EAAA,qBAAA;EADV;AACF","sourcesContent":["#pwb-container {\n    display: none;\n\n    &.show-add-accounts {\n        display: block;\n    }\n\n}\n\n.accountlist-grid {\n    @media (max-width: 400px) { /* Adjust width as needed */\n        .radio-label ion-col {\n            font-size: 0.8rem; /* Reduce font size */\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
